
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.482 2.272V3.53H17.59v.004a2.481 2.481 0 011.703.667c.432.408.702.973.704 1.598H20V17.73h-.003a2.208 2.208 0 01-.709 1.604 2.482 2.482 0 01-1.696.663V20H6.928v-.003a2.484 2.484 0 01-1.704-.668 2.203 2.203 0 01-.703-1.598h-.003v-2.674H2.41v-.003a2.484 2.484 0 01-1.703-.668 2.203 2.203 0 01-.704-1.598H0V2.271h.003A2.21 2.21 0 01.712.666 2.483 2.483 0 012.408.003V0H13.073v.003a2.481 2.481 0 011.703.668c.432.408.701.973.703 1.598h.003v.003zM13.655 3.53V2.27h.003a.532.532 0 00-.174-.386.601.601 0 00-.41-.163v.004H2.41V1.72a.599.599 0 00-.41.165.535.535 0 00-.172.386h.003v10.517h-.003c0 .148.067.285.174.386.106.1.252.163.41.163v-.004H4.519V5.801h.004a2.21 2.21 0 01.708-1.605 2.483 2.483 0 011.697-.662V3.53h6.727zm4.516 14.198V5.799h.003A.532.532 0 0018 5.413a.602.602 0 00-.41-.162v.003H6.926V5.25a.599.599 0 00-.41.164.535.535 0 00-.172.386h.003v11.93h-.003c0 .148.067.285.174.386.105.1.252.163.41.163v-.004h10.664v.004a.599.599 0 00.41-.165.534.534 0 00.172-.385h-.003v-.002z","fill":"#fff"}})])
          )
        }
      }
    